module.exports = __webpack_public_path__ + "img/message-mori.16224c39.jpg";